/** Public legal PDFs — served from e-doconline.co.uk (GCP), same pattern as NG connect (e-doconline.ng/documents). */
export const LEGAL_DOCUMENTS = {
  privacyPolicyUrl:
    'https://e-doconline.co.uk/documents/E-Doc%20ng%20Privacy%20Policy.pdf',
  termsAndConditionsUrl:
    'https://e-doconline.co.uk/documents/E-Doc%20Ng%20Terms%20%26%20Conditions.pdf',
} as const;
